import { approveAppointmentsApi as generatedApproveAppointmentsApi } from '../generated/appointments/approveAppointments';

const approveAppointmentsApi = generatedApproveAppointmentsApi.enhanceEndpoints({
  endpoints: {
    approveAppointments: {
      invalidatesTags: [
        { id: 'PENDING', type: 'UpcomingAppointment' as const },
        { id: 'UPCOMING', type: 'UpcomingAll' as const },
        { id: 'UPCOMING', type: 'UpcomingAppointment' as const },
        { type: 'Schedule' as const },
        { type: 'Slots' as const },
      ],
    },
  },
});

export const { useApproveAppointmentsMutation } = approveAppointmentsApi;
